module.exports = __webpack_public_path__ + "static/img/emoji_8.712af095.png";